import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { Volume2, VolumeX } from "lucide-react";
import { toast } from "sonner";

export default function AudioPlayer({ autoplay }) {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    if (!autoplay || !ref.current) return;
    ref.current
      .play()
      .then(() => setPlaying(true))
      .catch(() => {});
  }, [autoplay]);

  const toggle = () => {
    if (missing) {
      toast.info("No song uploaded yet — add your track as public/audio/song.mp3");
      return;
    }
    const a = ref.current;
    if (!a) return;
    if (playing) {
      a.pause();
      setPlaying(false);
    } else {
      a.play()
        .then(() => setPlaying(true))
        .catch(() => {});
    }
  };

  return (
    <>
      <audio
        ref={ref}
        src="/audio/song.mp3"
        loop
        preload="auto"
        onError={() => setMissing(true)}
      />
      <motion.button
        type="button"
        data-testid="audio-toggle-button"
        aria-label={playing ? "Mute the music" : "Play the music"}
        onClick={toggle}
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.2, duration: 0.6 }}
        className="fixed bottom-5 left-5 z-40 flex h-11 w-11 items-center justify-center rounded-full border border-[#C5A059]/50 bg-[#4A3B32]/90 text-[#E8D8B0] shadow-lg backdrop-blur transition-colors hover:bg-[#4A3B32]"
      >
        {playing ? <Volume2 size={18} /> : <VolumeX size={18} />}
      </motion.button>
    </>
  );
}
